import {switchCustomer} from '~api/auth';
import {AuthService} from '~api/auth.service';

/**
 * Switch to a different customer/org and reload the app with the new token.
 *
 * A full page reload guarantees a clean slate: cached data is discarded and
 * `/users/me` is re-fetched for the new customer (just like the login flow).
 *
 * @param customer  The customer/org identifier to switch to.
 * @param targetUrl Optional URL to load after switching. Defaults to the archive
 *                  page for a clean slate; pass the current URL to keep the user
 *                  on the page they deep-linked into.
 */
export async function switchCustomerAndReload(customer: string, targetUrl?: string): Promise<void> {
  await reclaimCustomerToken(customer);
  const resolved = new URL(targetUrl ?? '/archive', window.location.origin);
  window.location.replace(resolved.origin === window.location.origin ? resolved.toString() : '/archive');
}

export async function reclaimCustomerToken(customer: string): Promise<void> {
  const {accessToken} = await switchCustomer(customer);
  if (!AuthService.isLoggedIn()) {
    throw new Error('Session was terminated while switching customer');
  }
  AuthService.setToken(accessToken);
}
